import { render, staticRenderFns } from "./transferError.vue?vue&type=template&id=5ce5f49c&scoped=true&"
import script from "./transferError.vue?vue&type=script&lang=js&"
export * from "./transferError.vue?vue&type=script&lang=js&"
import style0 from "./transferError.vue?vue&type=style&index=0&id=5ce5f49c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5f49c",
  null
  
)

export default component.exports